import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { CartEvents, PromoCodeListResponse } from '@cargos/sprintpay-models';
import { Subject, take } from 'rxjs';
import { CartBillService, ConfigService } from 'src/app/shared/services';
import { PromoCodesService } from 'src/app/shared/services/promo-code.service';

@Component({
    selector: 'app-cart-items',
    templateUrl: './cart-items.component.html',
    styleUrls: ['./cart-items.component.scss'],
    standalone: false,
})
export class CartListComponent implements OnInit, OnDestroy {
    private unsubscribe$: Subject<void>;
    public deletingCart = false;
    public chargesURL: string;
    public cartSplitByAwbAndFlight = false;
    public destination: string | null = null;
    public labelAWB: string = '';
    public isNeededConfirmation: boolean = true;
    public editable: boolean = true;
    @Input() aboveThreshold: boolean = false;

    constructor(
        private cartBillService: CartBillService,
        private router: Router,
        private configService: ConfigService,
        private promoCodesService: PromoCodesService
    ) {
        this.unsubscribe$ = new Subject<void>();
        this.chargesURL = this.configService.getChargesURL();
    }

    ngOnInit(): void {
        this.getConfig();
        this.getPromoCodesByUser();
    }

    ngOnDestroy(): void {
        this.unsubscribe$.next();
        this.unsubscribe$.complete();
    }

    getConfig(): void {
        this.cartSplitByAwbAndFlight = this.configService.logicBaseOnFlightNumberAndFlightDate();
        this.labelAWB = this.configService.getLabelAWB();
    }

    deleteCart(event: CartEvents | null): void {
        if (!event || this.deletingCart) {
            return;
        }

        this.deletingCart = true;
        this.cartBillService.newEvent(CartEvents.cartDeleted);
        const cartPaymentRequests = this.cartBillService.getCartPaymentRequests();

        if (!cartPaymentRequests.length) {
            this.router.navigate([this.chargesURL]);
        }
        setTimeout(() => {
            this.deletingCart = false;
        }, 500);
    }

    getPromoCodesByUser(): void {
        this.promoCodesService
            .getPromoCodesByUserRequest$()
            .pipe(take(1))
            .subscribe({
                next: (promoCodeListResponse: PromoCodeListResponse[]) => {
                    this.promoCodesService.setPromoCodeListByUser(promoCodeListResponse);
                },
            });
    }
}
